module.exports = __webpack_public_path__ + "static/media/alert-icon.7ee2c640.svg";